import { CopyButton } from '@/components/ui/CopyButton'
import { IdeaCard } from '@/components/ui/idea-card'
import { Demo, DsSection } from '../primitives'

const DESCRIPTION =
  'You are running $1.94 against the target you set. Nine cents across the miles this fleet turns is about $4,800 a month.'

const VARIANTS: { prop: string; card: React.ReactNode }[] = [
  {
    prop: 'actionLabel="Send to Cai"',
    card: (
      <IdeaCard
        title="Build a plan to get cost per mile to $1.85"
        description={DESCRIPTION}
        actionLabel="Send to Cai"
      />
    ),
  },
  {
    prop: 'badge="Beta"',
    card: (
      <IdeaCard
        title="Model adding three more trucks"
        description={DESCRIPTION}
        badge="Beta"
        actionLabel="Send to Cai"
      />
    ),
  },
  {
    prop: 'upsell',
    card: (
      <IdeaCard
        title="Insurance with Cai"
        description="Buy your policy through Cai and the agent can chase claims, issue certificates and handle the renewal."
        upsell
        actionLabel="Get your quotes"
        href="/insure"
      />
    ),
  },
]

export function IdeaCardSection() {
  return (
    <DsSection id="idea-card" title="Idea card">
      <Demo label="Variants" className="flex max-w-2xl flex-col gap-6">
        {VARIANTS.map(({ prop, card }) => (
          <div key={prop} className="flex flex-col gap-2">
            {card}
            <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
              <span>{prop}</span>
              <CopyButton
                value={prop}
                className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
              />
            </div>
          </div>
        ))}
      </Demo>
    </DsSection>
  )
}
